import { useForm, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { yupFormResolver } from 'hooks/forms/yupFormResolver'
import {
  CustomerFeeWalletFormData,
  useCustomerFeeWalletSchema,
} from '../schemas/customerFeeWalletSchema'

export const useCustomerFeeWalletForm = () => {
  const { t } = useTranslation()
  const formSchema = useCustomerFeeWalletSchema(t)

  const form = useForm<CustomerFeeWalletFormData>({
    resolver: yupFormResolver<CustomerFeeWalletFormData>(formSchema),
    defaultValues: {
      walletReference: '',
    },
  })

  const {
    control,
    formState,
    clearErrors,
    resetField,
    setValue,
    register,
    trigger,
    setError,
    handleSubmit,
  } = form

  const formValues = useWatch({ control }) as CustomerFeeWalletFormData

  return {
    formValues,
    formState,
    errors: formState.errors,
    clearErrors,
    resetField,
    setValue,
    register,
    setError,
    trigger,
    handleSubmit,
    form,
  }
}
